/**
 * @generated SignedSource<<9b8ab03d47b7ce25fbbe2a464e3e9357>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CustomColor = "A" | "B" | "C" | "D" | "E" | "F";
export type RestrictionMemberVisibility = "NONE" | "RESTRICTION_ONLY" | "SLOTS_AND_RESTRICTION" | "SLOTS_AND_RESTRICTION_INLINE" | "SLOTS_ONLY";
export type SlotPricingPreviewMode = "HIDDEN" | "HOURLY" | "STARTING_AT";
import { FragmentRefs } from "relay-runtime";
export type useTimeListComponentsAgendaFragment_agenda$data = {
  readonly availableTimes: ReadonlyArray<{
    readonly bookingRates?: ReadonlyArray<{
      readonly maxPrice: number | null | undefined;
      readonly minPrice: number | null | undefined;
    } | null | undefined> | null | undefined;
    readonly capacity: number;
    readonly courseBucket: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly dateTime: string | null | undefined;
    readonly playerRates?: ReadonlyArray<{
      readonly maxPrice: number | null | undefined;
      readonly minPrice: number | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pricingPreview?: {
      readonly amount: number | null | undefined;
      readonly mode: SlotPricingPreviewMode;
    } | null | undefined;
    readonly seriesLength: number | null | undefined;
    readonly time: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly blockingRestrictions: {
    readonly edges: ReadonlyArray<{
      readonly liftAt: string | null | undefined;
      readonly node: {
        readonly displayName: string | null | undefined;
        readonly id: string;
        readonly liftBookingRuleWindow?: {
          readonly daysAhead: number;
          readonly time: string;
        } | null | undefined;
        readonly memberMessage?: string | null | undefined;
        readonly memberVisibility?: RestrictionMemberVisibility | null | undefined;
        readonly name: string;
        readonly slotCriteria?: {
          readonly allDay: boolean;
          readonly courses: {
            readonly count: number;
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly name: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly endAt: string | null | undefined;
          readonly startAt: string | null | undefined;
        } | null | undefined;
        readonly visibilityColor?: CustomColor | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly blocks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly blockSeries: {
          readonly color: CustomColor;
          readonly name: string;
        };
        readonly courses: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly name: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly durationMins: number | null | undefined;
        readonly id: string;
        readonly startAt: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly date: string;
  readonly events: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly eventSeries: {
          readonly name: string;
        };
        readonly eventSessions: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly agenda: {
                readonly date: string;
              };
              readonly endAt: string | null | undefined;
              readonly startAt: string | null | undefined;
              readonly timeSlots: {
                readonly lastDateTime: string | null | undefined;
              } | null | undefined;
              readonly " $fragmentSpreads": FragmentRefs<"TimeListEventsCard_EventSession">;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly id: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly facility: {
    readonly durations: ReadonlyArray<number | null | undefined> | null | undefined;
    readonly minMaxGroupSize: {
      readonly max: number | null | undefined;
      readonly min: number | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"useFacilityCourseNoun_facility">;
  };
  readonly id: string;
  readonly infoRestrictions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly displayName: string | null | undefined;
        readonly id: string;
        readonly memberMessage?: string | null | undefined;
        readonly memberVisibility?: RestrictionMemberVisibility | null | undefined;
        readonly name: string;
        readonly slotCriteria?: {
          readonly allDay: boolean;
          readonly courses: {
            readonly count: number;
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly name: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly endAt: string | null | undefined;
          readonly startAt: string | null | undefined;
        } | null | undefined;
        readonly visibilityColor?: CustomColor | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useTimeListComponentsAgendaFragment_agenda";
};
export type useTimeListComponentsAgendaFragment_agenda$key = {
  readonly " $data"?: useTimeListComponentsAgendaFragment_agenda$data;
  readonly " $fragmentSpreads": FragmentRefs<"useTimeListComponentsAgendaFragment_agenda">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "bookingType",
    "value": "STANDARD"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  (v0/*: any*/),
  (v4/*: any*/)
],
v6 = [
  {
    "alias": "minPrice",
    "args": [
      {
        "kind": "Variable",
        "name": "duration",
        "variableName": "minDuration"
      },
      {
        "kind": "Variable",
        "name": "playerCount",
        "variableName": "minGroupSize"
      }
    ],
    "kind": "ScalarField",
    "name": "totalDurationBookingPrice",
    "storageKey": null
  },
  {
    "alias": "maxPrice",
    "args": [
      {
        "kind": "Variable",
        "name": "duration",
        "variableName": "maxDuration"
      }
    ],
    "kind": "ScalarField",
    "name": "totalDurationBookingPrice",
    "storageKey": null
  }
],
v7 = {
  "kind": "Literal",
  "name": "memberVisibility",
  "value": [
    "RESTRICTION_ONLY",
    "SLOTS_AND_RESTRICTION"
  ]
},
v8 = {
  "kind": "Literal",
  "name": "type",
  "value": [
    "RESTRICTION"
  ]
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberMessage",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibilityColor",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberVisibility",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allDay",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endAt",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "CourseEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Course",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000
},
v19 = [
  (v18/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "courseBucketIds"
    },
    {
      "kind": "RootArgument",
      "name": "endTime"
    },
    {
      "kind": "RootArgument",
      "name": "groupSize"
    },
    {
      "kind": "RootArgument",
      "name": "isMember"
    },
    {
      "kind": "RootArgument",
      "name": "maxDuration"
    },
    {
      "kind": "RootArgument",
      "name": "minDuration"
    },
    {
      "kind": "RootArgument",
      "name": "minGroupSize"
    },
    {
      "kind": "RootArgument",
      "name": "startTime"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useTimeListComponentsAgendaFragment_agenda",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Facility",
      "kind": "LinkedField",
      "name": "facility",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useFacilityCourseNoun_facility"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "durations",
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v2/*: any*/),
          "concreteType": "GroupSize",
          "kind": "LinkedField",
          "name": "minMaxGroupSize",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "min",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "max",
              "storageKey": null
            }
          ],
          "storageKey": "minMaxGroupSize(bookingType:\"STANDARD\")"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "courseBucketIds",
          "variableName": "courseBucketIds"
        },
        {
          "kind": "Variable",
          "name": "maxDuration",
          "variableName": "maxDuration"
        },
        {
          "kind": "Variable",
          "name": "minDuration",
          "variableName": "minDuration"
        },
        {
          "kind": "Variable",
          "name": "playerCount",
          "variableName": "groupSize"
        },
        {
          "kind": "Variable",
          "name": "timeGte",
          "variableName": "startTime"
        },
        {
          "kind": "Variable",
          "name": "timeLte",
          "variableName": "endTime"
        }
      ],
      "concreteType": "AgendaTime",
      "kind": "LinkedField",
      "name": "availableTimes",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dateTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v2/*: any*/),
          "kind": "ScalarField",
          "name": "capacity",
          "storageKey": "capacity(bookingType:\"STANDARD\")"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CourseBucket",
          "kind": "LinkedField",
          "name": "courseBucket",
          "plural": false,
          "selections": (v5/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "seriesLength",
          "storageKey": null
        },
        {
          "condition": "isMember",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "bookingRates",
              "args": [
                {
                  "kind": "Literal",
                  "name": "ratePeriodType",
                  "value": "BOOKING"
                }
              ],
              "concreteType": "AgendaTimeRate",
              "kind": "LinkedField",
              "name": "rates",
              "plural": true,
              "selections": (v6/*: any*/),
              "storageKey": "rates(ratePeriodType:\"BOOKING\")"
            },
            {
              "alias": "playerRates",
              "args": [
                {
                  "kind": "Literal",
                  "name": "ratePeriodType",
                  "value": "PLAYER"
                }
              ],
              "concreteType": "AgendaTimeRate",
              "kind": "LinkedField",
              "name": "rates",
              "plural": true,
              "selections": (v6/*: any*/),
              "storageKey": "rates(ratePeriodType:\"PLAYER\")"
            }
          ]
        },
        {
          "condition": "isMember",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SlotPricingPreview",
              "kind": "LinkedField",
              "name": "pricingPreview",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "amount",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "alias": "blockingRestrictions",
      "args": [
        {
          "kind": "Literal",
          "name": "bookingType",
          "value": [
            "STANDARD"
          ]
        },
        {
          "kind": "Literal",
          "name": "isBlocking",
          "value": true
        },
        (v7/*: any*/),
        (v8/*: any*/)
      ],
      "concreteType": "AgendaBookingRulesConnection",
      "kind": "LinkedField",
      "name": "bookingRules",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AgendaBookingRulesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "liftAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v4/*: any*/),
                (v9/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v10/*: any*/),
                    (v11/*: any*/),
                    (v12/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BookingRuleWindow",
                      "kind": "LinkedField",
                      "name": "liftBookingRuleWindow",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "daysAhead",
                          "storageKey": null
                        },
                        (v3/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BookingRuleSlotCriteria",
                      "kind": "LinkedField",
                      "name": "slotCriteria",
                      "plural": false,
                      "selections": [
                        (v13/*: any*/),
                        (v14/*: any*/),
                        (v15/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "CourseConnection",
                          "kind": "LinkedField",
                          "name": "courses",
                          "plural": false,
                          "selections": [
                            (v16/*: any*/),
                            (v17/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "BookingRestrictionRule",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "bookingRules(bookingType:[\"STANDARD\"],isBlocking:true,memberVisibility:[\"RESTRICTION_ONLY\",\"SLOTS_AND_RESTRICTION\"],type:[\"RESTRICTION\"])"
    },
    {
      "alias": "infoRestrictions",
      "args": [
        {
          "kind": "Literal",
          "name": "isBlocking",
          "value": false
        },
        (v7/*: any*/),
        (v8/*: any*/)
      ],
      "concreteType": "AgendaBookingRulesConnection",
      "kind": "LinkedField",
      "name": "bookingRules",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AgendaBookingRulesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v4/*: any*/),
                (v9/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v10/*: any*/),
                    (v11/*: any*/),
                    (v12/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BookingRuleSlotCriteria",
                      "kind": "LinkedField",
                      "name": "slotCriteria",
                      "plural": false,
                      "selections": [
                        (v13/*: any*/),
                        (v14/*: any*/),
                        (v15/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "CourseConnection",
                          "kind": "LinkedField",
                          "name": "courses",
                          "plural": false,
                          "selections": [
                            (v16/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "CourseEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Course",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    (v4/*: any*/),
                                    (v0/*: any*/)
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "BookingRestrictionRule",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "bookingRules(isBlocking:false,memberVisibility:[\"RESTRICTION_ONLY\",\"SLOTS_AND_RESTRICTION\"],type:[\"RESTRICTION\"])"
    },
    {
      "alias": null,
      "args": [
        (v18/*: any*/),
        {
          "kind": "Literal",
          "name": "isVisibleToMembers",
          "value": true
        }
      ],
      "concreteType": "TimeSlotBlockConnection",
      "kind": "LinkedField",
      "name": "blocks",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSlotBlockEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeSlotBlock",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v14/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "durationMins",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BlockSeries",
                  "kind": "LinkedField",
                  "name": "blockSeries",
                  "plural": false,
                  "selections": [
                    (v4/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "color",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseConnection",
                  "kind": "LinkedField",
                  "name": "courses",
                  "plural": false,
                  "selections": [
                    (v17/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "blocks(first:1000,isVisibleToMembers:true)"
    },
    {
      "alias": null,
      "args": (v19/*: any*/),
      "concreteType": "EventConnection",
      "kind": "LinkedField",
      "name": "events",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Event",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventSeries",
                  "kind": "LinkedField",
                  "name": "eventSeries",
                  "plural": false,
                  "selections": [
                    (v4/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": (v19/*: any*/),
                  "concreteType": "EventSessionConnection",
                  "kind": "LinkedField",
                  "name": "eventSessions",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "EventSessionEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "EventSession",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v14/*: any*/),
                            (v15/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Agenda",
                              "kind": "LinkedField",
                              "name": "agenda",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/)
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "TimeSlotConnection",
                              "kind": "LinkedField",
                              "name": "timeSlots",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "lastDateTime",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "TimeListEventsCard_EventSession"
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "eventSessions(first:1000)"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "events(first:1000)"
    }
  ],
  "type": "Agenda",
  "abstractKey": null
};
})();

(node as any).hash = "366a1a37aa1476a7b7384c258fdb09ca";

export default node;
